<template>
  <div class="p-4 rounded-xl shadow-md bg-white space-y-2">
    <p class="text-sm font-medium text-gray-500 mb-6">Bonnes pratiques</p>
    <ul class="space-y-4">
      <li v-for="(point, index) in bulletPoints" :key="index" class="flex items-start gap-2 text-sm text-black">
        <span class="text-green-600 text-lg leading-5">✅</span>
        <span>{{ point }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "BestPractices",
  props: {
    bulletPoints: {
      type: Array,
      required: true,
    },
  },
};
</script>
